module.exports = __webpack_public_path__ + "img/upload_document_icon.60fbb553.png";